import React from 'react'
import '../Eyeq.css'
import Common_title from '../../common-components/common-title/Common_title'

const Sports = () => {
    return (
        <>
            <div className='radiotabsec' >
                <Common_title title={'Sports'} titleblack={'lens'} />
                <div className='contsec'>
                    <div className='row'>
                        <div className='col-md-5 mb-md-0 mb-3'>
                            <img className='eyeqban' src={process.env.PUBLIC_URL + '/assets/images/eyeq/sports.png'} />
                        </div>
                        <div className='col-md-7 '>
                            <div className='contdiv'>
                                <p className='content'>We have the largest collection and facility to make the best sports sunglasses as per your requirements So you can focus on your Game when we are focusing on your glasses</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sports